import { FileText } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useDocumentSourceFile, type DraftProposalDocumentKind } from '@/api/queries/draft-proposals';

/**
 * The name of the file a document was created from (#241), with its SHA-256
 * fingerprint on hover and in a collapsible detail. Renders nothing for a
 * document created otherwise, or while the link is unknown.
 */
export function SourceFileNote({
  kind,
  documentId,
  className,
}: {
  kind: DraftProposalDocumentKind;
  documentId: string | undefined;
  className?: string;
}) {
  const { data: source } = useDocumentSourceFile(kind, documentId);
  if (!source) return null;
  const fingerprint = `Empreinte SHA-256 : ${source.contentSha256}`;
  return (
    <div className={cn('flex flex-wrap items-center gap-2 text-sm text-slate-600', className)} data-testid="source-file-note">
      <FileText className="h-4 w-4 text-slate-400" aria-hidden="true" />
      <span title={fingerprint}>
        Créé depuis le fichier <span className="font-medium text-slate-800">{source.fileName}</span>
      </span>
      <details className="text-xs text-slate-500">
        <summary className="cursor-pointer select-none">Empreinte</summary>
        <code className="break-all">{source.contentSha256}</code>
      </details>
    </div>
  );
}
